'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationClearAll = function CommunicationClearAll(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z' })
  );
};
CommunicationClearAll = (0, _pure2.default)(CommunicationClearAll);
CommunicationClearAll.displayName = 'CommunicationClearAll';
CommunicationClearAll.muiName = 'SvgIcon';

exports.default = CommunicationClearAll;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/communication/clear-all.js
// module id = 2054
// module chunks = 0